import installationInstructions from './installationInstructions';

const pepSwitchContent = {
  installationInstructions
}

export { pepSwitchContent };
